import React from 'react';
import { Menu } from 'antd';

export const Sidenav = ({
  selectedItem,
  children,
}: React.PropsWithChildren<{ selectedItem: string | undefined }>) => (
  <>
    <Menu
      className="wk-sidenav"
      theme="dark"
      selectedKeys={[selectedItem!]}
      mode="inline"
    >
      {children}
    </Menu>
    <style jsx>{`
      // make menu follow zero width of collapsed Sider
      :global(.wk-sidenav.ant-menu-inline-collapsed) {
        width: 0px;
      }
    `}</style>
  </>
);
